import * as React from "react";
import type { SVGProps } from "react";
const SvgCursorSelectHand = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    fill="none"
    viewBox="0 0 25 25" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.804 13.5V10a1.5 1.5 0 0 0-1.5-1.5v0a1.5 1.5 0 0 0-1.5 1.5v6.5l-.901-.901a1.554 1.554 0 0 0-2.198 0v0a1.554 1.554 0 0 0-.194 1.961l2.699 4.049a2 2 0 0 0 1.665.891h5.288a2 2 0 0 0 1.985-1.752l.542-4.337a2 2 0 0 0-1.662-2.222z"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.429 18.501h1.821a2 2 0 0 0 2-2V4.531a2 2 0 0 0-2-2h-16a2 2 0 0 0-2 2v11.97a2 2 0 0 0 2 2h2.888"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.029 5.022q-.005 0-.005.005t.005.005.005-.005-.005-.005M7.572 5.022q-.005 0-.005.005t.005.005.005-.005-.005-.005M10.111 5.022q-.005 0-.005.005t.005.005.005-.005-.005-.005"
    />
  </svg>
);
export default SvgCursorSelectHand;
